import moment from "@/utils/moment";

import dateAndTimeMixin from "./generic/dateAndTimeMixin";
import accountMixin from "./accountMixin";
import addressMixin from "./addressMixin";
import currencyMixin from "./generic/currencyMixin";
import couponMixin from "./couponMixin";

const STATES = {
  created: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "criado"
  },
  scheduled: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "aguardando pagamento"
  },
  requested_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "criando dependências"
  },
  failed_to_create_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "erro na criação de dependências"
  },
  created_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "aguardando pagamento"
  },
  failed_to_request_payment: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "erro na criação do pagamento"
  },
  payment_requested: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "pagamento solicitado"
  },
  waiting_payment: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "aguardando pagamento"
  },
  paid: {
    icon: "/static/icon_order_status_ok.svg",
    translatedName: "pago"
  },
  not_paid: {
    icon: "/static/icon_order_status_canceled.svg",
    translatedName: "não pago"
  },
  rebooking: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "remarcando"
  },
  rescheduling: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "reagendando"
  },
  provisioning: {
    icon: "/static/icon_order_status_ok.svg",
    translatedName: "em limpeza"
  },
  service_not_provided: {
    icon: "/static/icon_order_status_danger.svg",
    translatedName: "diarista não compareceu"
  },
  complete: {
    icon: "/static/icon_order_status_ok.svg",
    translatedName: "completo"
  },
  waiting_refund: {
    icon: "/static/icon_order_status_canceled.svg",
    translatedName: "cancelado"
  },
  cancelled: {
    icon: "/static/icon_order_status_canceled.svg",
    translatedName: "cancelado"
  },
  refunded: {
    icon: "/static/icon_order_status_canceled.svg",
    translatedName: "reembolsado"
  }
};

const STATES_TO_CANCEL = [
  "scheduled",
  "requested_on_gateway",
  "created_on_gateway",
  "payment_requested",
  "waiting_payment",
  "paid",
  "rebooking",
  "not_paid"
];
const STATES_TO_RESCHEDULE = ["paid"];

const STATES_TO_ACCUSE_ABSENCE = ["paid", "provisioning"];

const STATES_TO_REQUEST_INVOICE = [
  "paid",
  "provisioning",
  "complete",
  "service_not_provided"
];
const STATES_TO_CHECKOUT = [
  "scheduled",
  "created_on_gateway",
  "payment_requested",
  "waiting_payment"
];

const STATES_TO_RATE = ["complete"];

const STATES_TO_CREATE_ON_GATEWAY = ["scheduled", "fail_to_create_on_gateway"];

const STATES_TO_SEE_PHONE = ["paid", "provisioning", "service_not_provided"];

const DAYS_TO_PROVE_PAYMENT = 4;

// methods
const isOrderPayable = order => {
  return STATES_TO_CHECKOUT.includes(order.status);
};

const isOrderProvisioning = order => {
  return order.status === "provisioning";
};

const isOrderPaid = order => {
  return order.status === "paid";
};

const statesToCheckout = () => {
  return STATES_TO_CHECKOUT;
};

const daysBeforeOrder = order => {
  return moment(order.schedule_event.starts_at)
    .startOf("day")
    .diff(moment().startOf("day"), "days");
};

export default {
  data() {
    return {
      daysToProvePayment: DAYS_TO_PROVE_PAYMENT
    };
  },
  methods: {
    statesToCheckout,
    daysBeforeOrder,
    canRate(status) {
      return STATES_TO_RATE.includes(status);
    },
    canCancel(order) {
      const diff = moment.duration(
        moment(order.schedule_event.starts_at).diff(moment())
      );

      return diff.asHours() >= 3 && STATES_TO_CANCEL.includes(order.status);
    },
    canReschedule(order) {
      if (order.status === "service_not_provided") return true;

      return (
        moment(order.schedule_event.starts_at).isAfter(
          moment().subtract(3, "hours")
        ) && STATES_TO_RESCHEDULE.includes(order.status)
      );
    },
    canRequestInvoice(status) {
      return STATES_TO_REQUEST_INVOICE.includes(status);
    },
    canGoToCheckout(order) {
      if (this.getPendingBoleto(order.payments)) return false;
      else if (this.haveValidPayment(order.payments)) return false;

      //Checking if order status is valid to create payment
      return STATES_TO_CHECKOUT.includes(order.status);
    },

    haveTimeToPay(created_at, serverTime = moment().unix()) {
      let diffTime =
        moment(created_at)
          .add(20, "minutes")
          .unix() - serverTime;

      return diffTime > 0;
    },

    haveValidPayment(payments) {
      if (payments.length) {
        let validPayment = payments.find(
          payment => payment.status === "authorized"
        );
        return validPayment;
      }
    },

    getPendingBoleto(payments) {
      return payments.find(
        el =>
          el.status === "waiting" && el.funding_instrument.type === "boletos"
      );
    },

    mustBeCreatedOnGateway(payable) {
      return (
        payable.type === "orders" &&
        STATES_TO_CREATE_ON_GATEWAY.includes(payable.status)
      );
    },

    isAOrder(type) {
      return type === "orders";
    },

    isInPeriodOfProofPayment(startsAt) {
      let deadlineForSendingProofOfPayment = moment()
        .startOf("day")
        .businessAdd(DAYS_TO_PROVE_PAYMENT);
      startsAt = moment(startsAt).startOf("day");

      return startsAt < deadlineForSendingProofOfPayment;
    },

    hasAPendingBoleto(payments) {
      return this.getPendingBoleto(payments);
    },

    mustProvePayment(payable) {
      return (
        this.isAOrder(payable.type) &&
        this.hasAPendingBoleto(payable.payments) &&
        this.isInPeriodOfProofPayment(payable.schedule_event.starts_at)
      );
    },
    orderHasDelayed(order) {
      return (
        moment(order.schedule_event.starts_at).isBefore(moment()) &&
        STATES_TO_ACCUSE_ABSENCE.includes(order.status)
      );
    },
    canSeePhone(order) {
      return STATES_TO_SEE_PHONE.includes(order.status);
    },
    paidWithBoleto(order) {
      const payment = this.haveValidPayment(order.payments);

      return payment && payment.funding_instrument.type === "boletos";
    },
    isOrderPayable,
    isOrderProvisioning,
    isOrderPaid,
    internalProfessional(order) {
      return (
        accountMixin.filters.fullName(order.professional.account) ==
        "Donie Assistente Virtual"
      );
    }
  },

  filters: {
    formatPhone(phone) {
      if (!phone) return "";

      return `(${phone.area_code}) ${phone.number}`;
    },
    getIcon(status) {
      return STATES[status].icon;
    },

    getTranslatedName(status) {
      return STATES[status].translatedName;
    },

    getOrderDuration(order) {
      const hours = dateAndTimeMixin.filters.fromMinutesToHours(
        order.schedule_event.duration
      );

      return dateAndTimeMixin.filters.stringifyHours(hours);
    },

    getOrderScheduleDay(order) {
      const scheduleTo = order.schedule_event.starts_at;

      const date = dateAndTimeMixin.filters.formatDate(
        scheduleTo,
        "DD/MM/YYYY (dddd)"
      );
      const time = dateAndTimeMixin.filters.formatDate(scheduleTo, "HH");

      return `${date} às ${time}h`;
    },

    getOrderProfessionalFullName(order) {
      return accountMixin.filters.fullName(order.professional.account);
    },

    getOrderAddressName(order) {
      return addressMixin.filters.name(order.address);
    },

    getOrderAmount(order) {
      return currencyMixin.filters.toCurrency(order.total);
    },

    getOrderCouponName(order) {
      return couponMixin.filters.couponName(order.coupon);
    },

    getOrderCouponDiscount(order) {
      return couponMixin.filters.couponDiscount(order.coupon);
    },

    getOrderCouponDiscountAmount(order) {
      return couponMixin.filters.couponDiscountAmount(order.amount);
    },

    getOrderTotal(order) {
      return currencyMixin.filters.toCurrency(order.amount.total);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/orderMixin.js